import React, { useState } from "react";
import filter from "../assets/images/filter-icon.svg";
import backArrow from "../assets/images/arrow_icon.png";
import aiImg from "../assets/images/AI-Enhanced-Lightning.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ScriptBox = ({ responseHandler, updateResponse, backhandler }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [content, setContent] = useState({
    script: "",
    name: "",
    company: "",
    title: "",
    website: "",
    linkedInaddress: "",
  });

  const [response, setResponse] = useState();

  const generateResponse = async () => {
    const prompt = `I have a phone call with ${content.name} who has the following linked in address ${content.linkedInaddress} and who works at ${content.company} which has a website address of ${content.website}. I am going to try to convince ${content.name} to schedule a sales appointment with me and I want the first paragraph of my pitch to include something that might be of interest to ${content.name} based on his LinkedIn profile. I also want the second paragraph of my script to reference a recent news item about ${content.company}. Please search the internet for the most recent news story about ${content.company} and insert something about the news story in the second paragraph of my script. Include a reference to one of${content.company} products in the last paragraph of my script and the benefit ${content.name} will get from working with ${content.company} in relation to that ${content.company} product. Please adapt my current script to include these items. Here is my current script: ${content.script}`;

    const payload = {
      model: "gpt-3.5-turbo", // Ensure this is a correct chat model identifier
      messages: [{
          role: "user", content: prompt,
      },
          {role: "system", content: "Include  <br><br> tags in response to separate paragraphs. forecefully add two br tags to separate paragraphs"}],
    };
    try {
      const response = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer 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`, // Use Bearer token for authorization
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorDetails = await response.text();
        console.error("Error Response:", errorDetails);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Data from OpenAI API:", data);
      const res = data.choices[0].message.content;
      updateResponse(res);
      setResponse(res);
    } catch (error) {
      console.error("Error calling OpenAI API:", error);
      console.log("Failed to fetch response");
    }
  };

  const submitHandler = () => {
    generateResponse();
    responseHandler();
  };
  const totalSteps = 7;
  const [showModal, setShowModal] = useState(false);

  const handleNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div>
            <h5 className="mb-4">
              Let's personalize the script to your contact!
            </h5>
            <button
              className="mb-3 btn rounded-pill contactInfoModal"
              onClick={handleNextStep}
            >
              Ok
            </button>
          </div>
        );
      case 2:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label contactInfo-label">
                Contact Name
              </label>
              <input
                type="text"
                value={content.name}
                className={`form-control ${
                  content.name.length > 0 && "contactInfo-inputfield"
                }`}
                onChange={(e) =>
                  setContent({ ...content, name: e.target.value })
                }
              />
            </div>
            <button
              disabled={content.name.length < 3}
              className="btn rounded-pill contactInfoModal"
              onClick={handleNextStep}
            >
              Next
            </button>
          </div>
        );
      case 3:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label contactInfo-label">
                Contact Company Name
              </label>
              <input
                type="text"
                value={content.company}
                className={`form-control ${
                  content.company.length > 0 && "contactInfo-inputfield"
                }`}
                onChange={(e) =>
                  setContent({ ...content, company: e.target.value })
                }
              />
            </div>
            <button
              className="btn rounded-pill contactInfoModal me-2"
              onClick={handlePrevStep}
            >
              Previous
            </button>
            <button
              disabled={content.company.length < 3}
              className="btn rounded-pill contactInfoModal"
              onClick={handleNextStep}
            >
              Next
            </button>
          </div>
        );
      case 4:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label contactInfo-label">
                Contact Title
              </label>
              <input
                type="text"
                value={content.title}
                className={`form-control ${
                  content.title.length > 0 && "contactInfo-inputfield"
                }`}
                onChange={(e) =>
                  setContent({ ...content, title: e.target.value })
                }
              />
            </div>
            <button
              className="btn rounded-pill contactInfoModal me-2"
              onClick={handlePrevStep}
            >
              Previous
            </button>
            <button
              disabled={content.title.length < 3}
              className="btn rounded-pill contactInfoModal"
              onClick={handleNextStep}
            >
              Next
            </button>
          </div>
        );
      case 5:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label contactInfo-label">
                Contact Website
              </label>
              <input
                type="text"
                value={content.website}
                className={`form-control ${
                  content.website.length > 0 && "contactInfo-inputfield"
                }`}
                onChange={(e) =>
                  setContent({ ...content, website: e.target.value })
                }
              />
            </div>
            <button
              className="btn rounded-pill contactInfoModal me-2"
              onClick={handlePrevStep}
            >
              Previous
            </button>
            <button
              disabled={content.website.length < 3}
              className="btn rounded-pill contactInfoModal"
              onClick={handleNextStep}
            >
              Next
            </button>
          </div>
        );
      case 6:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label contactInfo-label">
                Contact Linkedln Address
              </label>
              <input
                type="text"
                value={content.linkedInaddress}
                className={`form-control ${
                  content.linkedInaddress.length > 0 && "contactInfo-inputfield"
                }`}
                onChange={(e) =>
                  setContent({ ...content, linkedInaddress: e.target.value })
                }
              />
            </div>
            <button
              className="btn rounded-pill contactInfoModal me-2"
              onClick={handlePrevStep}
            >
              Previous
            </button>
            <button
              disabled={content.linkedInaddress.length < 3}
              className="btn rounded-pill contactInfoModal"
              onClick={handleNextStep}
            >
              Next
            </button>
          </div>
        );
      // Define other steps similarly...
      default:
        return (
          <div>
            <div className="mb-3 text-center">
              <h5 className="mb-4">Click to Optimize!</h5>
              <button
                type="button"
                onClick={submitHandler}
                className="btn contactInfo-button"
              >
                <img
                  src={aiImg}
                  className="mt-0 mx-auto"
                  width={100}
                  alt="aiImg"
                />
              </button>
              {/* <OverlayTrigger
                key="1"
                placement="left"
                overlay={
                  <Tooltip id="tooltip-left" className="custom-tooltip">
                    <span className="custom-tooltip-inner">
                      Optimizes your script using AI technology.
                    </span>
                  </Tooltip>
                }
              >
                <button
                  type="button"
                  onClick={submitHandler}
                  className="btn contactInfo-button"
                >
                  <img
                    src={aiImg}
                    className="mt-0 mx-auto"
                    width={100}
                    alt="aiImg"
                  />
                </button>
              </OverlayTrigger> */}
            </div>
            <button
              className="btn rounded-pill contactInfoModal me-2"
              onClick={handlePrevStep}
            >
              Previous
            </button>
          </div>
        );
    }
  };
  return (
    <div className="container cl-main-container">
      <div className="card p-3 bg-transparent cl-main-card">
        <div className="card cl-secondary-card">
          <div className="card-body p-4">
            <div className="cl-filter-icon">
              <label>
                <span>
                  <img className="img-fluid" src={filter} alt="Filter" />
                </span>
                Conversion Lab
              </label>
              <hr className="cl-heading-border" />
            </div>
            <div className="form-floating mt-3">
              <div className="p-2 cl-internal-area-container">
                <textarea
                  className="form-control cl-floating-textarea-placeholder"
                  onChange={(e) =>
                    setContent({ ...content, script: e.target.value })
                  }
                  id="cl-floating-textarea"
                  placeholder="Paste Script Here"
                  cols="80"
                  rows="12"
                ></textarea>
              </div>
            </div>
            <div className="mt-2 d-flex bd-highlight">
              <div className="p-2 flex-grow-1 bd-highlight">
                <button className="btn cl-goback-btn" onClick={backhandler}>
                  <img src={backArrow} width={15} alt="Go Back" /> Go Back
                </button>
              </div>
              <div className="p-2 bd-highlight">
                <button
                  className="btn rounded-pill contactInfoModal me-2"
                  disabled={content.script.length < 3}
                  onClick={toggleModal}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal with multiple steps */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        id="contactInfoModal"
        tabIndex="-1"
        aria-labelledby="contactInfoModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ zIndex: 9999 }}
        >
          <div className="modal-content contactInfo-modalContent">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close contactInfo-btn-rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={toggleModal}
              ></button>
            </div>
            <div className="container p-3">{renderStep()}</div>
          </div>
        </div>
        {/* Backdrop for modal */}
        {showModal && <div className="modal-backdrop fade show"></div>}
      </div>
    </div>
  );
};

export default ScriptBox;
